/**
 * 深拷贝
 * @param {object}} source
 * @returns
 */
export function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "deepClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

export function isEmpty(data = null) {
  //base type
  if (data === undefined || data === null || data === "") return true;
  if (typeof data === "boolean") return false;
  if (typeof data === "number") return !data;
  if (data instanceof Error) return data.message === "";

  //reference type
  switch (Object.prototype.toString.call(data)) {
    case "[object String]":
    case "[object Array]":
      return !data.length;
    case "[object File]":
    case "[object Map]":
    case "[object Set]":
      return !data.size;
    case "[object Object]":
      return !Object.keys(data).length;
    default:
      return false;
  }
}
// 两位小数补0
export function return2Float(value) {
  var value = Math.round(value * Math.pow(10, 2)) / Math.pow(10, 2);
  var s = value.toString().split(".");
  if (s.length == 1) {
    value = value.toString() + ".00";
    return value;
  }
  if (s.length > 1) {
    if (s[1].length < 2) {
      value = value.toString() + "0";
    }
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js